import React from 'react'
import { cn } from '@/lib/utils'

interface ChatBoxResizeHandlesProps {
  isResizing: boolean
  resizeDirection: string
  onMouseDown: (e: React.MouseEvent, direction: string) => void
}

const ChatBoxResizeHandles: React.FC<ChatBoxResizeHandlesProps> = ({
  isResizing,
  resizeDirection,
  onMouseDown,
}) => {
  return (
    <>
      {/* Corner handles */}
      <div
        className={cn(
          'absolute -top-1 -left-1 w-3 h-3 cursor-nw-resize z-10 transition-colors duration-150 rounded-sm',
          isResizing && resizeDirection === 'top-left'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'top-left')}
      />
      <div
        className={cn(
          'absolute -top-1 -right-1 w-3 h-3 cursor-ne-resize z-10 transition-colors duration-150 rounded-sm',
          isResizing && resizeDirection === 'top-right'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'top-right')}
      />
      <div
        className={cn(
          'absolute -bottom-1 -left-1 w-3 h-3 cursor-sw-resize z-10 transition-colors duration-150 rounded-sm',
          isResizing && resizeDirection === 'bottom-left'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'bottom-left')}
      />
      <div
        className={cn(
          'absolute -bottom-1 -right-1 w-3 h-3 cursor-se-resize z-10 transition-colors duration-150 rounded-sm',
          isResizing && resizeDirection === 'bottom-right'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'bottom-right')}
      />

      {/* Edge handles */}
      <div
        className={cn(
          'absolute -top-1 left-3 right-3 h-2 cursor-n-resize z-10 transition-colors duration-150',
          isResizing && resizeDirection === 'top'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'top')}
      />
      <div
        className={cn(
          'absolute -bottom-1 left-3 right-3 h-2 cursor-s-resize z-10 transition-colors duration-150',
          isResizing && resizeDirection === 'bottom'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'bottom')}
      />
      <div
        className={cn(
          'absolute -left-1 top-3 bottom-3 w-2 cursor-w-resize z-10 transition-colors duration-150',
          isResizing && resizeDirection === 'left'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'left')}
      />
      <div
        className={cn(
          'absolute -right-1 top-3 bottom-3 w-2 cursor-e-resize z-10 transition-colors duration-150',
          isResizing && resizeDirection === 'right'
            ? 'bg-blue-500/20'
            : 'hover:bg-gray-200/50'
        )}
        onMouseDown={(e) => onMouseDown(e, 'right')}
      />
    </>
  )
}

export default ChatBoxResizeHandles
